import React from 'react';
import { businessServices } from '../../data/businessServices';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const BusinessInternet = () => {
  const internetService = businessServices.find(service => service.title === "Internet Business");

  return (
    <>
      <Hero
        title="Internet Business"
        subtitle="Soluții de internet dedicate pentru afaceri, cu SLA garantat"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-business-internet.jpg"
        icon={internetService?.icon}
        iconLabel={internetService?.title}
      />

      {internetService && (
        <ServiceSection
          service={internetService}
          index={0}
          pricingFirst
          id="tarife"
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default BusinessInternet;
